export { default as PaymentMethodsModal } from './PaymentMethodsModal';
